import { STATUS } from '@/config/WIZARD';

export default {
  deals: [],
  unsavedDeals: {},
  status: STATUS.LOADING,
  isSlideValidating: false,
  menuIsOpen: false,
};
